import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7f5368f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "CostStandards" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "mt-4 bg-white rounded" }
const _hoisted_4 = { class: "p-5 flex items-center justify-end" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-file-excel mr-2" }, null, -1))
const _hoisted_6 = { class: "p-4" }
const _hoisted_7 = {
  key: 0,
  class: "flex flex-col items-center justify-center text-sm text-gray-400 select-none"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-1" }, "Загрузка норм себестоимости...", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-red-500" }, " При получении списка норм себестоимости произошла ошибка ", -1))
const _hoisted_10 = { key: 2 }
const _hoisted_11 = {
  key: 1,
  class: "max-w-full overflow-hidden overflow-x-auto"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_cost_standard_excel = _resolveComponent("cost-standard-excel")!
  const _component_cost_standards_actions = _resolveComponent("cost-standards-actions")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_new_button = _resolveComponent("new-button")!
  const _component_cost_standards_filters = _resolveComponent("cost-standards-filters")!
  const _component_new_limit = _resolveComponent("new-limit")!
  const _component_new_pagination = _resolveComponent("new-pagination")!
  const _component_loader = _resolveComponent("loader")!
  const _component_new_table = _resolveComponent("new-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.state.is_excel)
      ? (_openBlock(), _createBlock(_component_cost_standard_excel, {
          key: 0,
          onCancel: _ctx.closeExcel,
          onConfirm: _ctx.closeExcel
        }, null, 8, ["onCancel", "onConfirm"]))
      : _createCommentVNode("", true),
    (_ctx.actions_state.is_actions_opened)
      ? (_openBlock(), _createBlock(_component_cost_standards_actions, {
          key: 1,
          "is-create": _ctx.actions_state.is_create,
          "is-update": _ctx.actions_state.is_update,
          "initial-value": _ctx.actions_state.initial_value,
          onClose: _ctx.closeActions,
          onCreated: _ctx.onCostStandardsCreated,
          onUpdated: _ctx.onCostStandardsCreated
        }, null, 8, ["is-create", "is-update", "initial-value", "onClose", "onCreated", "onUpdated"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_page_title, { title: "Нормы себестоимости" }),
      _createVNode(_component_new_button, { onClick: _ctx.startCreate }, {
        default: _withCtx(() => [
          _createTextVNode(" Создать норму себестоимости ")
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createVNode(_component_cost_standards_filters, {
      class: "mt-9",
      loading: _ctx.state.is_loading,
      disabled: _ctx.state.is_loading,
      onSubmit: _ctx.onFiltersChanged,
      onReset: _ctx.onFiltersReset
    }, null, 8, ["loading", "disabled", "onSubmit", "onReset"]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_new_button, {
          onClick: _ctx.openExcel,
          class: "mr-2"
        }, {
          default: _withCtx(() => [
            _hoisted_5,
            _createTextVNode("Импорт норм себестоимости ")
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_new_limit, {
          disabled: _ctx.state.is_loading || _ctx.state.is_failed,
          value: _ctx.state.filters.limit,
          "total-items": _ctx.state.filters.total_items,
          onChange: _ctx.onLimitChange
        }, null, 8, ["disabled", "value", "total-items", "onChange"]),
        _createVNode(_component_new_pagination, {
          class: "ml-6",
          disabled: _ctx.state.is_loading || _ctx.state.is_failed,
          "current-page": _ctx.state.filters.current_page,
          "total-pages": _ctx.state.filters.total_pages,
          onChangePage: _ctx.onChangePage
        }, null, 8, ["disabled", "current-page", "total-pages", "onChangePage"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_ctx.state.is_loading || _ctx.state.is_failed || _ctx.state.list.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              (_ctx.state.is_loading)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_loader, { class: "primary" }),
                    _hoisted_8
                  ], 64))
                : (_ctx.state.is_failed)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _hoisted_9,
                      _createVNode(_component_new_button, {
                        class: "mt-1",
                        onClick: _ctx.loadCostStandards
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Перезагрузить ")
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ], 64))
                  : (_ctx.state.list.length === 0)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_10, "Список норм себестоимости пуст"))
                    : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createVNode(_component_new_table, {
                "has-index-column": "",
                columns: _ctx.TABLE_COLUMNS,
                rows: _ctx.state.list
              }, {
                "table-index": _withCtx(() => []),
                td: _withCtx(({ row, column }) => [
                  (column.key === 'capacities[0]')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (row.capacities[0])
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(_ctx.formatAmount(row.capacities[0].price)), 1)
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode(_toDisplayString(_ctx.formatAmount(0)), 1)
                            ], 64))
                      ], 64))
                    : (column.key === 'capacities[1]')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          (row.capacities[1])
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(_ctx.formatAmount(row.capacities[1].price)), 1)
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(_toDisplayString(_ctx.formatAmount(0)), 1)
                              ], 64))
                        ], 64))
                      : (column.key === 'capacities[2]')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            (row.capacities[2])
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode(_toDisplayString(_ctx.formatAmount(row.capacities[2].price)), 1)
                                ], 64))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode(_toDisplayString(_ctx.formatAmount(0)), 1)
                                ], 64))
                          ], 64))
                        : (column.key === 'capacities[3]')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                              (row.capacities[3])
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(_toDisplayString(_ctx.formatAmount(row.capacities[3].price)), 1)
                                  ], 64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createTextVNode(_toDisplayString(_ctx.formatAmount(0)), 1)
                                  ], 64))
                            ], 64))
                          : (column.key === 'capacities[4]')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                (row.capacities[4])
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode(_toDisplayString(_ctx.formatAmount(row.capacities[4].price)), 1)
                                    ], 64))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createTextVNode(_toDisplayString(_ctx.formatAmount(0)), 1)
                                    ], 64))
                              ], 64))
                            : (column.key === 'actions')
                              ? (_openBlock(), _createBlock(_component_new_button, {
                                  key: 5,
                                  onClick: ($event: any) => (_ctx.startUpdate(row))
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_12
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                                  _createTextVNode(_toDisplayString(row[column.key]), 1)
                                ], 64))
                ]),
                _: 1
              }, 8, ["columns", "rows"])
            ]))
      ])
    ])
  ]))
}